export const GET_ECHO_LIST_DATA = 'GET_ECHO_LIST_DATA'
export const GET_ECHO_DATA = 'GET_ECHO_DATA'
export const GET_ECHO_DOCUMENT = 'GET_ECHO_DOCUMENT'
export const ECHO_DOC_LOADING = 'ECHO_DOC_LOADING'
export const SET_ECHO_LOADING = 'SET_ECHO_LOADING'
export const RESET_ECHO_MODAL = 'RESET_ECHO_MODAL'
export const CLEAR_ECHO = 'CLEAR_ECHO'
